import { FrameAction } from '@aipb/frame/model';

import { Component, Input } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fr-sidebar-action-list',
  templateUrl: './sidebar-action-list.component.html',
  styleUrls: ['./sidebar-action-list.component.scss'],
  imports: [CommonModule, MatIconModule, MatListModule, TranslocoModule]
})
export class SidebarActionListComponent {
  @Input() actions: FrameAction[] = [];
}
